<div class="header">
  <h2>Creazione <strong>Nuova Macro Categoria</strong></h2>
  <div class="breadcrumb-wrapper hidden-xs">
    <ol class="breadcrumb">
      <li><a [routerLink]="['/checklist']">Checklist</a></li>
      <li><a [routerLink]="['/checklist/' + checklist.id_checklist]">Dettaglio</a></li>
      <li class="active">Nuova Macro Categoria</li>
    </ol>
  </div>
</div>
<div class="row">
  <div class="col-lg-12 portlets">
    <div class="panel">
      <div class="panel-content">
        <form (ngSubmit)="onSubmit()" #checklistCreateForm="ngForm" role="form" class="form-horizontal form-validation">
          <div class="form-group">
            <label for="checklist" class="col-sm-3 control-label">Checklist *</label>
            <div class="col-sm-6">
              <input type="text"
                     id="checklist"
                     class="form-control-plaintext"
                     style="font-size: 1.4rem !important;"
                     readonly
                     [value]="checklist.name">
            </div>
          </div>

          <div class="form-group">
            <label for="code" class="col-sm-3 control-label">Codice *</label>
            <div class="col-sm-6 prepend-icon">
              <input type="text"
                     id="code"
                     name="code"
                     class="form-control"
                     placeholder="Inserisci Codice..."
                     autocomplete="off"
                     [ngClass]="{
                        'form-error': !(code.valid || code.pristine),
                        'form-success': code.valid
                     }"
                     [(ngModel)]="checklistCategory.code"
                     #code="ngModel">
              <i class="icon-key"></i>
              <div [hidden]="code.valid || code.pristine"
                   class="form-error valid">
                Il codice presenta un errore.
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="title" class="col-sm-3 control-label">Titolo *</label>
            <div class="col-sm-6 prepend-icon">
              <input type="text"
                     id="title"
                     name="title"
                     class="form-control"
                     placeholder="Inserisci Titolo..."
                     minlength="3"
                     required
                     autocomplete="off"
                     [ngClass]="{
                        'form-error': !(name.valid || name.pristine),
                        'form-success': name.valid
                     }"
                     [(ngModel)]="checklistCategory.name"
                     #name="ngModel">
              <i class="icon-info"></i>
              <div [hidden]="name.valid || name.pristine"
                   class="form-error valid">
                Inserisci almeno 3 caratteri.
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="description" class="col-sm-3 control-label">Descrizione</label>
            <div class="col-sm-6 prepend-icon">
              <input type="text"
                     id="description"
                     name="description"
                     class="form-control"
                     placeholder="Inserisci Descrizione..."
                     autocomplete="off"
                     [ngClass]="{
                        'form-error': !(description.valid || description.pristine),
                        'form-success': description.valid
                     }"
                     [(ngModel)]="checklistCategory.description"
                     #description="ngModel">
              <i class="icon-book-open"></i>
              <div [hidden]="description.valid || description.pristine"
                   class="form-error valid">
                La descrizione è richiesta.
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="description" class="col-sm-3 control-label">Indice</label>
            <div class="col-sm-6 prepend-icon">
              <input type="number"
                     id="index"
                     name="index"
                     class="form-control"
                     placeholder="Inserisci Indice..."
                     autocomplete="off"
                     [ngClass]="{
                        'form-error': !(index.valid || index.pristine),
                        'form-success': index.valid
                     }"
                     [(ngModel)]="checklistCategory.index"
                     #index="ngModel">
              <i class="icon-list"></i>
              <div [hidden]="index.valid || index.pristine"
                   class="form-error valid">
                L'indice è richiesto.
              </div>
            </div>
          </div>

          <div class="text-center m-t-20">
            <button type="submit"
                    class="btn btn-embossed btn-primary"
                    [disabled]="!checklistCreateForm.form.valid">
              <i class="icon-plus"></i> Crea nuova Macro Categoria</button>
          </div>

          <div [hidden]="checklistCategoryCreationResult" class="alert alert-danger">
            Non è stato possibile inserire la Macro Categoria, riprovare.
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
